<template>
  <div class="weui-cell" :class="[point ? 'weui-cell_access' : '', themeName]">
    <div class="weui-cell__hd" v-show="icon&&icon.length>0">
      <img :src="icon">
      <slot name="head"></slot>
    </div>
    <div class="weui-cell__bd">
      <p>{{ title }}</p>
      <p>{{ subTitle}}</p>
    </div>
    <div class="weui-cell__ft">{{ desc }}
      <slot name="foot"></slot>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>
<script>
  export default {
    name: 'c-cell-item',
    props: {
      icon: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: ''
      },
      desc: {
        type: String,
        default: ''
      },
      point: {
        type: Boolean,
        default: true
      },
      themeName: {
        type: String,
        default: ''
      },
      subTitle: {
        type: String,
        default: ''
      }
    },
    data () {
      return {}
    },
    components: {},
    created () {
    },
    mounted () {
    },
    beforeDestroy () {
    },
    methods: {},
    computed: {},
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?7ba9dd04